export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "Logg på",
    "login.form.hint.user": "Pålogging",
    "login.form.hint.password": "Passord",
    "login.form.checkbox.remember-me": "Husk meg",
    "login.form.button.sign-in": "Logg på",
    "login.form.message.invalid-user-credentials": "Påloggingsnavn eller brukernavn er feil",
    "login.form.message.user-required": "Angi et påloggingsnavn",
    "login.form.message.password-required": "Angi et passord",
    "login.form.button.forgot-password": "Har du glemt passordet?",
    "error.root-admin-login.title": "Feil 403 – forbudt",
    "error.root-admin-login.message": "Du er logget inn som en skrivebeskyttet administrator. For å få tilgang til Web Recovery konsollen, logg inn som en kundeleier-bruker eller administrator i stedet"
};
